import React, { useEffect, useState } from "react";
import { Checkbox, Input, Select, SelectItem } from "@nextui-org/react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import AuthLayout from "../../layouts/AuthLayout";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { addAuth } from "../../store/slices/authSlice";
import { getStates } from "../../store/slices/countrySlice";
import { getSuppliertype } from "../../store/slices/adminSlice";
import { useForm } from "react-hook-form";
import CustomButton from "../CustomButton";
import { toast } from "react-toastify";

const SignUp = () => {
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const { states } = useSelector((state) => state.country);
  const { totalData } = useSelector((state) => state.form);
  const { suppliertype } = useSelector((state) => state.admin);
  const [showPassword, setShowPassword] = useState(false);
  const [selectedRole, setSelectedRole] = useState(null);
  const [isChecked, setIsChecked] = useState({
    privacy: false,
    terms: false,
  });
  const [checkboxError, setCheckboxError] = useState(false);
  const handleCheckboxChange = (e) => {
    setIsChecked((prev) => ({ ...prev, [e.target.name]: e.target.checked }));
    setCheckboxError(false);
  };
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { role } = useParams();

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    reset,
  } = useForm({
    mode: "onChange",
    defaultValues: {
      country: "Australia",
    },
  });

  useEffect(() => {
    dispatch(getStates());
    dispatch(getSuppliertype());
  }, [selectedRole, reset, dispatch]);

  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.onload = (e) => {
        // console.log('File content:', e.target.result); // Base64 encoded string0
        resolve(e.target.result);
      };
      fileReader.readAsDataURL(file);

      fileReader.onerror = (error) => reject(error);
    });
  };

  const fileURL = localStorage.getItem("fileURL");

  const getForm = (totalData) => {
    const fileURL = localStorage.getItem("fileURL");
    const imageBlob = dataUrlToBlog(fileURL);
    const formData = new FormData();
    formData.append("image", imageBlob);
  };

  const dataUrlToBlog = (dataUrl) => {
    const byteString = atob(dataUrl.split(",")[1]);

    const mimeString = dataUrl.split(",")[0].split(":")[1].split(";")[0];

    const ab = new ArrayBuffer(byteString.length);

    const ia = new Uint8Array(ab);

    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    return new Blob([ab], { type: mimeString });
  };

  const onSubmit = async (data) => {
    let formData = {
      ...data,
      phone: String(data.phone),
    };
    for (const key in formData) {
      if (key === "confirm_password") {
        delete formData[key];
      }
    }

    Object.keys(formData).forEach((key) => {
      if (
        formData[key] === "" ||
        formData[key] === null ||
        formData[key] === undefined
      ) {
        delete formData[key];
      }
    });
    if (!isChecked.privacy || !isChecked.terms) {
      setCheckboxError(true);

      toast.error("Please Accept Both Privacy Policy and Terms & Conditions");

      return;
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/users/register?type=${role}`,

        formData
      );
      const responseData = response?.data.details;

      localStorage.setItem("accessToken", responseData.accessToken);

      localStorage.setItem("refreshToken", responseData.refreshToken);

      localStorage.setItem("role", responseData.user.role);

      // console.log(totalData);
      dispatch(addAuth({ ...responseData }));

      if (Object.keys(totalData).length > 0) {
        let imageD = totalData.images.map((item) => {
          const imagedata = dataUrlToBlog(item);
          // console.log(imagedata);
          return imagedata;
        });
        let filesArr = [];
        filesArr.forEach((file, index) => {
          formData.append(`images_${index}`, file);
        });
        let res = await axios.post(
          `${process.env.REACT_APP_SERVER_URL_V2}/requests/create`,
          { ...totalData, images: imageD },
          {
            headers: {
              "Content-Type": "multipart/form-data",
              authorization: `Bearer ${responseData.accessToken}`,
            },
          }
        );

        toast.success("Created successfully ⭐");
      }
      navigate("/requests");
      // reset();
    } catch (error) {
      toast.error(error?.response?.data.message);
    }
  };

  useEffect(() => {
    let token = localStorage.getItem("accessToken");
    if (token) {
      navigate("/requests");
    }
  }, [navigate]);

  return (
    <AuthLayout>
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <div className="text-center">
          <h2 className="md:text-3xl text-2xl mb-1">New Here?</h2>
          {role === "SUPPLIER" ? (
            <p>Register quickly and start quotes on requested parts.</p>
          ) : (
            <p>Register quickly and start requesting parts.</p>
          )}
        </div>
        <div className="mt-12 mb-8 [&>*:not(:last-child)]:mb-5">
          {role === "SUPPLIER" && (
            <>
              <div>
                <Input
                  {...register("company_name", {
                    required: "Company Name please",
                  })}
                  type="text"
                  variant="bordered"
                  label="Name of Company"
                  labelPlacement="outside"
                  placeholder=" "
                  isRequired
                  errorMessage={errors.company_name?.message}
                />
              </div>
              <div className="border-2 border-white">
                <Select
                  {...register("supplier_type")}
                  variant="bordered"
                  label="Supplier Type"
                  labelPlacement="outside"
                  placeholder=" "
                  isRequired
                  errorMessage={errors.supplier_type?.message}
                >
                  {suppliertype.map(
                    (item) =>
                      item?.id !== 0 && (
                        <SelectItem key={item.id}>{item.name}</SelectItem>
                      )
                  )}
                </Select>
              </div>
              <div className="border-2 border-white">
                <Input
                  {...register("abn_number")}
                  type="number"
                  min="0"
                  variant="bordered"
                  label="ABN"
                  labelPlacement="outside"
                  onWheel={(e) => e.target.blur()}
                  placeholder=" "
                  isRequired
                  errorMessage={errors.abn_number?.message}
                />
              </div>
            </>
          )}

          {role === "CUSTOMER" && (
            // <div>
            //   <Input
            //     {...register("business_name", {
            //       // required: "Business Name Is Required",
            //     })}
            //     type="text"
            //     variant="bordered"
            //     label="Name of Business (If any)"
            //     labelPlacement="outside"
            //     placeholder=" "
            //   // errorMessage={errors.business_name?.message}
            //   />
            // </div>

            <div className="border-2 border-white">
              <Input
                {...register("business_name")}
                type="text"
                variant="bordered"
                label="Name of Business (If any)"
                labelPlacement="outside"
                placeholder=" "
              />
            </div>
          )}

          <div className="grid sm:grid-cols-2 gap-5">
            <div>
              <Input
                {...register("first_name", {
                  required: "First Name Is Required",
                })}
                type="text"
                variant="bordered"
                label="First Name"
                labelPlacement="outside"
                placeholder=" "
                isRequired
                isInvalid={!!errors.first_name}
                errorMessage={errors.first_name?.message}
              />
            </div>

            <div>
              <Input
                {...register("last_name", {
                  required: "Last Name Is Required",
                })}
                type="text"
                variant="bordered"
                label="Last Name"
                labelPlacement="outside"
                isInvalid={!!errors.last_name?.message}
                isRequired
                placeholder=" "
                errorMessage={errors.last_name?.message}
                style={{ textTransform: "capitalize" }}
              />
            </div>
          </div>

          {/* <div>
            <Input
              {...register("email")}
              type="email"
              variant="bordered"
              label="Email"
              labelPlacement="outside"
              placeholder=" "
              isRequired
              errorMessage={errors.email?.message}
            />
          </div> */}

          <div className="border border-white">
            <Input
              {...register("email", {
                required: "Email Is Required",
                pattern: {
                  value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                  message: "Enter A Valid Email Address",
                },
              })}
              type="email"
              variant="bordered"
              label="Email"
              labelPlacement="outside"
              isInvalid={!!errors.email?.message}
              isRequired
              placeholder=" "
              errorMessage={errors.email?.message}
            />
          </div>

          <div className="border border-white">
            <Input
              {...register("phone", {
                required: "Phone Number is required",
                minLength: {
                  value: 10,
                  message: "Phone Number must be 10 digits",
                },
                maxLength: {
                  value: 10,
                  message: "Phone Number cannot exceed 10 digits",
                },
              })}
              type="number"
              variant="bordered"
              label="Phone Number"
              labelPlacement="outside"
              placeholder=" "
              isRequired
              isInvalid={!!errors.phone} // ✅ Add this
              errorMessage={errors.phone?.message} // ✅ Show message in red
              onWheel={(e) => e.target.blur()}
              onInput={(e) => {
                e.target.value = e.target.value.slice(0, 10);
              }}
            />
          </div>

          <div className="grid sm:grid-cols-2 gap-5">
            <div>
              <Input
                {...register("password", {
                  required: "Password Is Required",
                  minLength: {
                    value: 6,
                    message: "Password Must Be At Least 6 Characters",
                  },
                  pattern: {
                    value:
                      /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@$!%*?&#^_~()]{6,}$/,
                    message:
                      "Password must contain letters, numbers, and allowed special characters",
                  },
                })}
                type={showPassword ? "text" : "password"}
                variant="bordered"
                label="Password"
                labelPlacement="outside"
                isInvalid={!!errors.password}
                errorMessage={errors.password?.message}
                placeholder=" "
                isRequired
                endContent={
                  <button
                    className="focus:outline-none"
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? (
                      <AiOutlineEye className="password_eye_icon" />
                    ) : (
                      <AiOutlineEyeInvisible className="password_eye_icon" />
                    )}
                  </button>
                }
              />
            </div>

            <div>
              <Input
                {...register("confirm_password", {
                  required: "Confirm Password Is Required",
                  validate: (value) =>
                    value === watch("password") || "Passwords Do Not Match",
                })}
                type={showConfirmPassword ? "text" : "password"}
                variant="bordered"
                label="Confirm Password"
                labelPlacement="outside"
                placeholder=" "
                isRequired
                isInvalid={!!errors.confirm_password}
                errorMessage={errors.confirm_password?.message}
                onPaste={(e) => {
                  e.preventDefault();
                }}
                endContent={
                  <button
                    className="focus:outline-none"
                    type="button"
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  >
                    {showConfirmPassword ? (
                      <AiOutlineEye className="password_eye_icon" />
                    ) : (
                      <AiOutlineEyeInvisible className="password_eye_icon" />
                    )}
                  </button>
                }
              />
            </div>
          </div>

          <div className="grid sm:grid-cols-2 gap-5">
            <div>
              <Input
                {...register("address_line_1", {
                  required: "Address Line 1 Is Required",
                })}
                type="text"
                variant="bordered"
                label="Address Line 1"
                labelPlacement="outside"
                isRequired
                placeholder=" "
                isInvalid={!!errors.address_line_1?.message}
                errorMessage={errors.address_line_1?.message}
              />
            </div>

            {/* <div>
              <Input
                {...register("address_line_2", {
                  required: "Address Line 2 Is Required",
                })}
                type="text"
                variant="bordered"
                label="Address Line 2"
                labelPlacement="outside"
                isRequired
                placeholder=""
                errorMessage={errors.address_line_2?.message}
              />
            </div> */}

            <div>
              <Input
                // {...register("address_line_2")} // No `required` here
                type="text"
                variant="bordered"
                label="Address Line 2"
                labelPlacement="outside"
                placeholder=" "
                // errorMessage={errors.address_line_2?.message}
              />
            </div>
          </div>

          <div className="grid sm:grid-cols-2 gap-5">
            {role === "CUSTOMER" && (
              <div>
                <Select
                  {...register("Industry", {
                    required: "Industry Is Required",
                  })}
                  variant="bordered"
                  label="Industry"
                  labelPlacement="outside"
                  isRequired
                  placeholder=" "
                  errorMessage={errors.Industry?.message}
                  isInvalid={!!errors.Industry?.message}
                >
                  <SelectItem
                    key="Collision Repairer"
                    value="Collision Repairer"
                  >
                    Collision Repairer
                  </SelectItem>
                  <SelectItem key="Dismantler" value="Dismantler">
                    Dismantler
                  </SelectItem>
                  <SelectItem key="Mechanic" value="Mechanic">
                    Mechanic
                  </SelectItem>
                  <SelectItem key="Private" value="Private">
                    Private
                  </SelectItem>
                  <SelectItem key="Reseller" value="Reseller">
                    Reseller
                  </SelectItem>
                </Select>
              </div>
            )}

            <div>
              <Input
                {...register("country")}
                type="text"
                variant="bordered"
                label="Country"
                isRequired
                labelPlacement="outside"
                placeholder=" "
                isReadOnly
                className="pointer-events-none"
              />
            </div>

            <div>
              <Select
                {...register("state", {
                  required: "State Is Required",
                })}
                variant="bordered"
                label="State"
                labelPlacement="outside"
                isRequired
                placeholder=" "
                errorMessage={errors.state?.message}
                isInvalid={!!errors.state?.message}
              >
                {states?.length > 0 ? (
                  states.map((item) => (
                    <SelectItem key={item.name} value={item.name}>
                      {item.name}
                    </SelectItem>
                  ))
                ) : (
                  <SelectItem key={"No data"}>Fetching the data...</SelectItem>
                )}
              </Select>
            </div>
            <div>
              <Input
                {...register("postcode", {
                  required: "Post Code Is Required",
                  minLength: {
                    value: 4,
                    message: "Post Code Must Be At Least 4 Digits",
                  },
                  maxLength: {
                    value: 6,
                    message: "Post Code Cannot Exceed 6 Digits",
                  },
                })}
                type="number"
                variant="bordered"
                label="Post Code"
                labelPlacement="outside"
                isRequired
                isInvalid={!!errors.postcode} // ✅ Add this
                errorMessage={errors.postcode?.message}
                onWheel={(e) => e.target.blur()}
                placeholder=" "
              />
            </div>

            <div>
              <Input
                {...register("suburb", {
                  required: "Suburb Is Required",
                })}
                type="text"
                variant="bordered"
                label="Suburb"
                isRequired
                labelPlacement="outside"
                placeholder=" "
                errorMessage={errors.suburb?.message}
                isInvalid={!!errors.suburb?.message}
              />
            </div>

            {/* <div>
              <Input
                {...register("capricorn_number", {
                  // required: "Capricorn Number Is Required",
                  setValueAs: (value) => (value === "" ? null : parseFloat(value)),
                })}
                type="number"
                min="0"
                variant="bordered"
                label="Capricorn Number"
                labelPlacement="outside"
                onWheel={(e) => e.target.blur()}
                placeholder=" "
                // errorMessage={errors.capricorn_number?.message}
              />
            </div> */}

            <div>
              <Input
                {...register("capricorn_number", {
                  setValueAs: (value) =>
                    value === "" ? null : parseFloat(value),
                })}
                type="number"
                min="0"
                variant="bordered"
                label="Capricorn Supplier Number"
                labelPlacement="outside"
                onWheel={(e) => e.target.blur()}
                placeholder=" "
              />
            </div>
          </div>

          <div className="mt-8 mb-8">
            <Checkbox
              name="privacy"
              isSelected={isChecked.privacy}
              onChange={handleCheckboxChange}
              size="sm"
              color="warning"
            >
              Accept our{" "}
              {/* <Link to="/requests" className="auth_link_2">
          Privacy Policy
        </Link> */}
              Privacy Policy
            </Checkbox>
          </div>

          <div className="mt-5 mb-8">
            <Checkbox
              name="terms"
              isSelected={isChecked.terms}
              onChange={handleCheckboxChange}
              size="sm"
              color="warning"
            >
              Accept{" "}
              {/* <Link to="/requests" className="auth_link_2">
          Terms and Conditions
        </Link> */}
              Tearms And Condition
            </Checkbox>
          </div>
        </div>
        <div>
          <CustomButton
            text="Sign Up"
            disabled={!isChecked.privacy || !isChecked.terms}
          />
        </div>

        <div className="text-sm mt-8">
          {role === "CUSTOMER" && (
            <div
              className="flex justify-center items-center gap-2"
              onClick={() => {
                localStorage.setItem("firstCustomer", 1);
              }}
            >
              {/* <p>Want to create a request?</p>
              <Link to="/requests/create" className="auth_link">
                Request
              </Link> */}
            </div>
          )}
        </div>
        <div className="text-sm mt-8">
          <div className="flex justify-center items-center gap-2">
            <p>Already have an account?</p>
            <Link to="/login" className="auth_link">
              Login
            </Link>
          </div>
        </div>
      </form>
    </AuthLayout>
  );
};

export default SignUp;
